module.exports = __webpack_public_path__ + "static/img/index.1f4fedf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index.png
// module id = XGqZ
// module chunks = 0